import { Product } from '@protos/product';
import ApiClient from '@services/ApiClient';

export const getDecimalPlaces = (num: number): number => {
  if (Number.isInteger(num)) return 0;
  const match = num.toString().match(/\.(\d+)/);
  return match ? match[1].length : 0;
};

const formatLotValue = (contractSize: number, quantityUnit: string) => {
  if (quantityUnit === 'unspecified') {
    return '';
  }
  return `1 Lot = ${contractSize.toLocaleString('en-US')} ${quantityUnit.toUpperCase()}`;
};

export const getLotValue = async (prod: Product, apiClient: ApiClient) => {
  if (prod.exchange_symbols.length > 0) {
    const exchangeSymbol = prod.exchange_symbols[0];
    return formatLotValue(exchangeSymbol.contract_size, exchangeSymbol.quantity_unit);
  }

  if (prod.calendar_type === 'spread') {
    const underlying = await apiClient.getProductBySymbol(prod.underlying_symbol);
    const underlyingExchangeSymbol = underlying?.exchange_symbols?.[0];

    if (underlyingExchangeSymbol) {
      return formatLotValue(underlyingExchangeSymbol.contract_size, underlyingExchangeSymbol.quantity_unit);
    }
  }

  return '';
};
